module.exports = __webpack_public_path__ + "static/media/tip-active.d8187a2e.svg";